export { resolveSwitchConditionalProperties } from './resolveSwitchConditionalProperties'
